'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

var _colors$baseColors = _styles.colors.baseColors,
    grey = _colors$baseColors.grey,
    charcoalGrey = _colors$baseColors.charcoalGrey,
    white = _colors$baseColors.white;
exports.default = {
	banner: function banner(open, statusColor) {
		return {
			transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
			boxSizing: 'border-box',
			borderRadius: '3px',
			border: '2px solid  ' + statusColor,
			backgroundColor: white,
			display: open ? 'flex' : 'none',
			padding: '16px',
			fontFamily: _styles.typography.fontStack.fontFamily,
			fontSize: '14px',
			color: charcoalGrey,
			marginBottom: '0.5em',
			minHeight: '78px'
		};
	},

	icon: {
		width: '30px',
		marginRight: '16px'
	},

	text: {
		flex: '100%',
		marginTop: '4px'
	},

	close: {
		color: grey,
		fontSize: '24px'
	},

	closeContainer: {
		padding: 0,
		width: '24px',
		height: '24px',
		marginTop: '3px'
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMMessageBanner/styles/index.js